import { gql } from "@apollo/client";

export const SIMPLE_OUTLETS_QUERY = gql`
  query GetOutlets {
    outlets {
      id
      label
      supportsUnpaidOrders
      archived
      tables {
        id
        name
        qrHash
      }
      printers {
        id
      }
      outletShifts {
        id
        name
        shiftStartInSeconds
        shiftDurationInSeconds
        activeDays
      }
    }
  }
`;

export const OUTLETS_QUERY = gql`
  query GetOutlets {
    outlets {
      id
      identifier
      label
      description
      labelForPickup
      latitude
      longitude
      address
      contactNumber
      email
      archived
    }
  }
`;

export const OUTLETS_WITH_STATIONS_QUERY = gql`
  query GetOutlets {
    outlets {
      id
      identifier
      label
      archived
      stations {
        id
        name
        posEnabled
        cfdEnabled
        cashRegisterEnabled
        seatsEnabled
        reservationsEnabled
        posPrintOnlyEnabled
        kdsEnabled
        kioskEnabled
        onlineEnabled
        dispatchEnabled
        kioskConfig {
          id
          channelIdentifier
          channelLinkId
          pairingKey
        }
        printers {
          name
          serialNumber
        }
        kitchenDisplay {
          id
        }
      }
    }
  }
`;

export const OUTLETS_WITH_POS_LAYOUT_QUERY = gql`
  query GetOutletsWithPosLayout {
    outlets {
      id
      label
      posLayoutId
      archived
    }
  }
`;
